import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    gap: theme.other.spacing._8,
    overflowX: 'auto',
    alignItems: 'center',
  },
  pill: {
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._16}px`,
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray2[1]}`,
    borderRadius: '50em',
    color: theme.colors.gray2[6],
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    whiteSpace: 'nowrap',

    '&.isActive': {
      backgroundColor: theme.colors.gray2[6],
      color: theme.white,
      borderColor: theme.colors.gray2[6],
    },

    '&.isLoading': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },

    '@media (hover: hover)': {
      transition: 'opacity 150ms ease-in-out',

      '&:hover': {
        backgroundColor: theme.colors.gray2[3],
        borderColor: theme.colors.gray2[3],
        // opacity: 0.5,
      },
    },

    '> svg:first-child': {
      marginLeft: -theme.other.spacing._4,
    },
    '> svg:last-child': {
      marginRight: -theme.other.spacing._6,
    },
  },

  clearButton: {
    width: 20,
    height: 20,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.white,
    marginRight: /* eslint-disable-line local-rules/use-theme-tokens */ -10,

    '&:hover': {
      backgroundColor: theme.colors.gray2[6],
    },
  },

  divider: {
    width: 1,
    height: 24,
    backgroundColor: theme.colors.gray2[1],
  },

  modalBody: {
    maxHeight: '70vh',
    overflowY: 'auto',
  },
  drawerBody: {
    paddingTop: theme.other.spacing._16,
    maxHeight: '100vh',
    overflowY: 'auto',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },
}));

export default useStyles;
